import { useEffect } from 'react';

import { type User } from '@atlaskit/teams-client/types';

import { useUser } from '../../main';

export const useTeamsUser = (userId: string, skip?: boolean) => {
	const [users, { getUser, setUserData, ...rest }] = useUser();
	const userState = users[userId];

	useEffect(() => {
		if (!skip) {
			getUser(userId);
		}
	}, [getUser, skip, userId]);

	return {
		...rest,
		data: userState?.user,
		isLoading: userState?.isLoading,
		error: userState?.error,
		refetch: (): Promise<void> => getUser(userId, true),
		setUserData: (data: Partial<User>): void => setUserData(userId, data),
	};
};
